import type { FormInputType } from '@/components/UI/Form/types'

import { NPS_RATINGS } from '../sessionFeedback'

const OTHER = 'other'
const BEHAVIOR = 'behavior'

export const EXPLAIN_REASONS = [OTHER, BEHAVIOR]

export default function getSeriesWithdrawFormInputs({
  isTutorWithdrawingMember,
  askForBootcampNPS,
}: {
  isTutorWithdrawingMember: boolean
  askForBootcampNPS: boolean
}): FormInputType[] {
  const tutorReasons = [
    {
      value: 'attendance',
      label: 'Did not follow attendance policy',
    },
    {
      value: 'expectations',
      label:
        'Did not meet other expectations of this Series (e.g. prerequisites, assignments, etc.)',
    },
    {
      value: BEHAVIOR,
      label: 'Behavior violated Schoolhouse.world policies',
    },
    {
      value: OTHER,
      label: 'Other',
    },
  ]
  const learnerReasons = [
    {
      value: 'not-interested',
      label: 'I am no longer interested in the material',
    },
    {
      value: 'unsatisfied',
      label: 'I am unsatisfied with the quality of this series',
    },
    {
      value: 'schedule',
      label: "I can't make the times",
    },
    {
      value: OTHER,
      label: 'Other',
    },
  ]

  const withdrawalReasons = isTutorWithdrawingMember ? tutorReasons : learnerReasons

  const bootcampNPSFormInput: FormInputType = {
    name: 'bootcamp_nps',
    type: 'select-tab',
    label:
      'Sorry to see you go! How likely would you be to recommend the SAT Bootcamp program to a ' +
      'friend, on a scale from 0 (not likely) to 10 (very likely)?',
    options: NPS_RATINGS.map(item => ({
      value: `${item}`,
      label: item,
    })),
    required: true,
    size: 6,
  }

  const formInputs: FormInputType[] = [
    {
      label: `Why are you withdrawing${
        isTutorWithdrawingMember ? ' the student' : ''
      } from this series?`,
      type: 'select',
      sublabel: isTutorWithdrawingMember
        ? 'This reason will be shared with the learner.'
        : 'This information will not be shared with the tutor.',
      name: 'reason',
      placeholder: 'Select an option',
      options: withdrawalReasons.map(item => ({
        value: item.value,
        label: item.label,
      })),
      required: true,
      size: 6,
    },
    {
      label: `Tell us more about why you're withdrawing${
        isTutorWithdrawingMember ? ' the student' : ''
      }.`,
      type: 'textarea',
      name: 'reason_explain',
      required: false,
      size: 6,
    },
  ]

  return [...formInputs, ...(askForBootcampNPS ? [bootcampNPSFormInput] : [])]
}
